import { getMdmConnectionUrl } from '../../../../constants/urls';
import { getRequest } from '../../../../middlewares/api/actions';

export const DDB_CONNECTION_CHANGE_CONNECTION_FORM = 'DDB_CONNECTION_CHANGE_CONNECTION_FORM';
export const DDB_CONNECTION_GET_MDM_CONNECTIONS = 'DDB_CONNECTION_GET_MDM_CONNECTIONS';

export const changeConnectionForm = fields => ({
    type: DDB_CONNECTION_CHANGE_CONNECTION_FORM,
    fields
});

export const getListMdmConnections = () => getRequest(
    DDB_CONNECTION_GET_MDM_CONNECTIONS,
    getMdmConnectionUrl(),
)